// VENTARA motion tokens — feels like breathing. No bounce. No spin.
export const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
    initial: { opacity: 0, y: 14 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.9, ease: EASE },
};

export const fadeIn = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 1.1, ease: EASE },
};

export const staggerParent = {
    initial: {},
    animate: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } },
};

export const staggerChild = {
    initial: { opacity: 0, y: 12 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};
